import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../Common';
import { FlexCenterRow, FlexColumnStart, FormCircularProgress } from './forms/FormElements';

export const ChangeLogViewer = ({ jobAssignmentId }) => {
    const { data: events, isLoading } = useQuery({
        queryKey: ['changeLogEvents', jobAssignmentId],
        queryFn: () => httpClient.post(ApiRoutes.jobAssignment.eventLog(), jobAssignmentId),
    });

    if (isLoading) {
        return <FormCircularProgress />;
    }

    return (
        <div className="table-responsive">
            <table className="table table-sm table-job-workflow-details table-bordered">
                <thead>
                    <tr>
                        <th colSpan="6">
                            <FlexCenterRow>
                                <span className="font-weight-bold">CHANGES</span>
                            </FlexCenterRow>
                        </th>
                    </tr>
                    <tr>
                        <th>Date</th>
                        <th>Action</th>
                        <th>Change</th>
                        <th>From</th>
                        <th>To</th>
                        <th>User</th>
                    </tr>
                </thead>
                <tbody>
                    {events.length > 0 ? events.map((e, i) => {
                        const eventDate = moment(moment.utc(e.eventDate).toDate()).local();

                        return (
                            <tr key={i}>
                                <td>
                                    <FlexColumnStart>
                                        {eventDate.format('M/D/YYYY')}
                                        <small>
                                            {' '}
                                            {eventDate.format('h:mm A')}
                                        </small>
                                    </FlexColumnStart>
                                </td>
                                <td>{e.eventType}</td>
                                <td>{e.columnName}</td>
                                <td>{e.previousValue ?? '-'}</td>
                                <td>{e.currentValue}</td>
                                <td>{e.modifiedByName}</td>
                            </tr>
                        );
                    })
                        : (
                            <tr>
                                <td colSpan="6">No events found.</td>
                            </tr>
                        )}
                </tbody>
            </table>
        </div>
    );
};

export default ChangeLogViewer;